import axios from 'axios';

const api = axios.create({
    baseURL: 'https://tumasaje.ar/api',
    withCredentials: true, // envía cookies automáticamente
});

export default api;